import { SHStack } from "@components/design-systems";
import SHSortableContext from "@components/design-systems/sh-sortable-context";
import { DragEndEvent } from "@dnd-kit/core";
import {
  ModelScreenerColumnSettingData,
  ModelScreenerColumnSettingDTO,
} from "@models/model-screener/entities/modelScreenerFilter";
import { MSTableColumnSettingMainHeader } from "@pages/managed-accounts/model-screener/components/model-screener-table/toolbar/column-setting/sortable-context/main-header";
import { useFormContext } from "react-hook-form";

type MSTableColumnSettingSortableContextProps = {
  disabled?: boolean;
};

export const MSTableColumnSettingSortableContext = ({
  disabled = false,
}: MSTableColumnSettingSortableContextProps) => {
  // Forms
  const { setValue, watch } = useFormContext<ModelScreenerColumnSettingDTO>();
  const formData = watch();

  // Functions
  const handleOnMainHeaderDragEnd = (
    _: DragEndEvent,
    items: ModelScreenerColumnSettingData[],
  ) => {
    const visibilityMap = new Map(
      formData.data?.map((elem) => [elem.id, elem.isVisible]) || [],
    );

    const newValue = items.map((item, index) => ({
      ...item,
      order: index + 1,
      isVisible: !!visibilityMap.get(item.id),
    }));

    setValue("data", newValue);
  };

  return (
    <SHStack height={"100%"} width={"100%"} gap={1} overflow={"hidden"}>
      <SHSortableContext
        items={formData.data}
        getItemId={(item) => item.id}
        renderSortableItem={(item) => {
          if (!item) return <></>;

          return (
            <MSTableColumnSettingMainHeader
              id={item.id}
              item={item}
              disabled={disabled}
            />
          );
        }}
        onDragEnd={handleOnMainHeaderDragEnd}
      />
    </SHStack>
  );
};
